const childRoutes = (prop) => [
    {
        path: 'application',
        name: prop + '.application',
        meta: { auth: true },
        component: () => import('../pages/application-list/List.vue')
    }
]

const routes = [{
    path: '/grant-allowance-service/citizen-card',
    name: 'grant_allowance_service.citizen_card',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('grant_allowance_service.citizen_card')
}]

export default routes
